<template>
    <div>
        <v-card-title>
            {{ item.title }}
            <v-spacer></v-spacer>
            <template v-if="isEmployee && !isHistory">
                <v-btn
                    @click.native="deleteItem()"
                    class="mr-1"
                    color="error"
                >
                    <v-icon class="mr-1">mdi-delete</v-icon>
                    {{ $t('common.delete') }}
                </v-btn>
                <modal-captable :loading="loading" :client="client" :company-info="companyInfo" :current-captable="item" :is-new="false" @close-captable-success-dialog="refreshAll"></modal-captable>
            </template>
        </v-card-title>
        <v-data-table
            :headers="getHeaders(item)"
            :items="getCaptableFormated(item.partners)"
            :items-per-page="-1"
            hide-default-footer
        >
            <template v-for="(column, index) in getHeaders(item)" #[`item.${column.value}`]="{ item }">
                <template functional v-if="column.percentual">
                    <span :key="index">{{ $helpers.getObjectValueByPath(item, column.value) }} %</span>
                </template>

                <template functional v-else>
                    <span :key="index" v-html="$helpers.getObjectValueByPath(item, column.value)"></span>
                </template>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import API from '@/api'
import ModalCaptable from '@/components/corporate/ModalCaptable'

export default {
    name: 'datatable-captable-read',
    props: ['client', 'companyInfo', 'item', 'isHistory'],
    components: {
        ModalCaptable
    },
    data: function () {
        return {
            loading: false
        }
    },
    computed: {
        isEmployee: function () {
            return this.$helpers.checkIsEmployee()
        }
    },
    methods: {
        getHeaders (item) {
            let headerFormated = [
                { text: this.$t('corporate.captable.history.headers.shareholder'), value: 'name', sortable: false },
                { text: this.$t('corporate.captable.history.headers.actions'), value: 'shares', align: 'center', sortable: false },
                { text: this.$t('corporate.captable.history.headers.percentual'), value: 'percentual', align: 'center', sortable: false, percentual: true }
            ]
            if (item.companyType !== 1) {
                headerFormated[0].text = this.$t('corporate.captable.history.headers.partners')
                headerFormated[1].text = this.$t('corporate.captable.history.headers.quotas')
            }
            return headerFormated
        },
        getCaptableFormated (content) {
            let contentFormated = [...content]
            let sumShare = contentFormated.reduce((accumulator, elemento) => {
                let value = elemento.shares
                if (elemento.shares.constructor === String) {
                    value = parseInt(value.replace(/[^0-9]/g, ''))
                }
                return (accumulator += value)
            }, 0)
            let sumPercentual = 0
            for (let index = 0; index < contentFormated.length; index++) {
                let value = contentFormated[index].shares
                if (contentFormated[index].shares.constructor === String) {
                    value = parseInt(value.replace(/[^0-9]/g, ''))
                }
                let percentual = ((value / sumShare) * 100)
                sumPercentual += percentual
                contentFormated[index].percentual = (Number.isInteger(percentual)) ? percentual : percentual.toFixed(2)
            }
            contentFormated.push({ name: this.$t('corporate.captable.history.total'), shares: sumShare, percentual: (Number.isInteger(sumPercentual)) ? Math.round(sumPercentual) : Math.round(sumPercentual).toFixed(2) })
            return contentFormated
        },
        refreshAll () {
            this.$emit('refresh-all')
        },
        async deleteItem () {
            if (confirm(this.$t('corporate.captable.history.deleteConfirm'))) {
                let endpoint = API.EndPoints.deleteCaptable
                let params = {
                    captableId: this.item.objectId,
                    clientId: this.client.objectId,
                    shareCapital: this.item.shareCapital
                }
                let msg = this.$t('corporate.captable.history.deleteSuccess')
                await new API(endpoint, params).request()
                    .catch((error) => { msg = (error.status !== 0) ? error.data.error : this.$t('common.save') })
                alert(msg)
                this.refreshAll()
            }
        }
    }
}
</script>
